/** Kichik classNames birlashtiruvchi — `clsx` o'rniga (yangi paket qo'shmaslik uchun, CLAUDE.md §3.4) */
export function cn(...classes: Array<string | false | null | undefined>): string {
  return classes.filter(Boolean).join(' ');
}
